import React from "react";
import { _ } from "libs";
import { Card } from "../../types";
import DropdownIconMenu from "../dropdownIconMenu";

type Props = {
	cards: Card[];
	onRemoveClicked: (card: Card) => void;
};

const CardList = ({ cards, onRemoveClicked }: Props) => {
	return (
		<div className="table cards">
			{cards.map(card => (
				<div className="cell" key={card.cardId} id={card.cardId}>
					<div className="item card medium" data-card-brand={card.brand.toLowerCase()}>
						<div className="itemImage">
							<div className="creditCardIcon" data-card-brand={card.brand.toLowerCase()} />
						</div>
						<div className="itemBody">
							<div className="cardNumber">•••• •••• •••• {card.last4}</div>
							<div className="cardExpiration">
								{card.expMonth}/{card.expYear}
							</div>
						</div>
						<div className="itemMenu">
							<DropdownIconMenu>
								{/* <span onClick={() => {}}>{_("card.edit")}</span> */}
								<span onClick={() => onRemoveClicked(card)}>{_("card.remove")}</span>
							</DropdownIconMenu>
						</div>
					</div>
				</div>
			))}
		</div>
	);
};

export default CardList;
